import CommonProducts from '../components/common-products';
import { useLang } from '@/app/utils/useLang';

const PowerDistribution: React.FC = () => {
    const { t } = useLang('landingPage.power_distribution');
    const items = [
        {
            img: '',
            label: t('item1_title'),
            productId: '8006700761242',
            variantId: '44244781531290',
            learnMore: 'https://ca.ecoflow.com/products/smart-home-panel-2?variant=44244781531290',
        },
        {
            img: '',
            label: t('item2_title'),
            productId: '7874417328282',
            variantId: '43762530025626',
            learnMore: 'https://ca.ecoflow.com/products/transfer-switch?variant=43762530025626',
        },
        {
            img: '',
            label: t('item3_title'),
            productId: '8012436603034',
            variantId: '44300038766746',
            learnMore: 'https://ca.ecoflow.com/products/powerinsight-home-energy-manager?variant=44300038766746',
        },
    ];

    return <CommonProducts items={items} title={t('title')} />;
};

export default PowerDistribution;
